export enum SupplierSpecialOffersTabs {
    Overview,
    Products,
}
